<main>
  <ul class="wrapper d-flex flex-wrap gap-0 align-items-stretch" *ngIf="typeCard !== 'menu'">
    <li *ngFor="let content of info" class="wrapper--item col-12 col-xl-4 mx-0 mb-2 px-2">
      <mat-card
        class="card"
        (click)="navigateTo(content)"
      >
        <mat-card-header class="card--header">
          <mat-card-title
            class="card--header__title"
            *ngIf="typeCard === 'requestList'"
          >
            <p class="card--header__label">
              {{ content.requestType | uppercase }}
            </p>
            <p>{{ content.requestNumber }}</p>
          </mat-card-title>
          <mat-card-title
            *ngIf="typeCard === 'authorizations'"
            class="card--header__title"
          >
            <p class="card--header__label">
              {{
                translate.translateRequestTypes(content.requestType) | uppercase
              }}
            </p>
            <p>{{ content.requestNumber }}</p>
          </mat-card-title>
          <mat-card-actions class="card--header__buttonArrow">
            <button
              (click)="navigateTo(content)"
              class="card--header__btn"
              mat-button
            >
              <mat-icon class="arrow">arrow_forward_ios</mat-icon>
            </button>
          </mat-card-actions>
        </mat-card-header>
        <mat-card-content class="card--content">
          <div class="d-flex flex-wrap">
            <div class="col-12 col-sm-6 col-xl-12">
              <mat-card-subtitle
                *ngIf="typeCard === 'requestList'"
                class="card--content__title"
                >{{
                  content.vehicle?.model
                    ? content.vehicle?.model.slice(0, 22) + '...'
                    : pendingModel
                }}
              </mat-card-subtitle>
              <mat-card-subtitle *ngIf="typeCard === 'authorizations'">
                <p class="card--header__labelModel">
                  {{
                    content.vehicle?.model
                      ? content.vehicle?.model.slice(0, 22) + '...'
                      : pendingModel
                  }}
                </p>
              </mat-card-subtitle>
              <p
                *ngIf="typeCard === 'requestList'"
                class="card--content__subtitle"
              >
                {{
                  content.vehicle?.plateNumber
                    ? content.plateNumber
                    : pendingPlate
                }}
              </p>
              <p
                *ngIf="typeCard === 'authorizations'"
                class="card--content__subtitle"
              >
                {{
                  content.vehicle?.plateNumber
                    ? content.vehicle?.plateNumber
                    : pendingPlate
                }}
              </p>
              <p *ngIf="typeCard === 'requestList'" class="card--content__date">
                {{ 'deliveryDate' | i18next }}:
                <span *ngIf="content.vehicle?.deliveryDate">{{
                  content.vehicle?.deliveryDate | date
                }}</span>
                <span *ngIf="!content.vehicle?.deliveryDate">Pendiente</span>
              </p>
            </div>
            <div class="car" *ngIf="typeCard === 'requestList'">
              <img
                class="car--img"
                [src]="content.vehicle?.image || '../../../../assets/img/NeutroNaranjaRojo_v2.png'"
                alt=""
              />
            </div>
          </div>
        </mat-card-content>
        <mat-card-footer
          class="card--footer"
          [ngClass]="statusStyles(content.statusGeneric)"
          *ngIf="typeCard === 'requestList'"
        >
          <div *ngIf="content.statusGeneric === 'Pendiente de aceptación'">
            <img
              src="../../../../assets/icons/emergency_home.svg"
              alt="Pendiente"
            />
          </div>
          <div *ngIf="content.statusGeneric === 'Todo correcto'">
            <img
              src="../../../../assets/icons/check_circle.svg"
              alt="Correcto"
            />
          </div>
          <div *ngIf="content.statusGeneric === 'Cancelada'">
            <img src="../../../../assets/icons/gpp_maybe.svg" alt="Error" />
          </div>
          <p class="card--footer__text">
            {{ content.statusGeneric }}
          </p>
        </mat-card-footer>
      </mat-card>
    </li>
  </ul>
  <ul *ngIf="typeCard === 'menu'" class="menu">
    <ng-container *ngFor="let title of info">
      <li
        *ngIf="
          handlePermissions.getPermission(title.value) &&
          title.value !== 'LOAN_CAR_POOL' &&
          title.value !== 'LOAN_LONG_TERMS' &&
          title.value !== 'LOAN_WEDDING' &&
          title.value !== 'CAMPAIGN' &&
          title.value !== 'RED_PLATES_APPROVE'
        "
        class="menu--item col-12 col-md-6 col-xl-4 mx-0 mb-2 px-2"
      >
        <mat-card (click)="navigateTo(title)" class="menu--card">
          <mat-card-content
            class="menu--card__content"
            (click)="navigateTo(title.value.toLowerCase())"
          >
            <mat-card-title class="menu--card__title">
              <p>{{ translate.translateRequestTypes(title.value) }}</p>
            </mat-card-title>
            <button class="menu--card__btn" mat-button>
              <mat-icon class="arrow">arrow_forward_ios</mat-icon>
            </button>
          </mat-card-content>
        </mat-card>
      </li>
    </ng-container>
    <li *ngIf="handlePermissions.getPermission('LOAN')" class="col-12 col-md-6 col-xl-4 mx-0 mb-2 px-2">
      <mat-card (click)="navigateTo('loan')" class="menu--card">
        <mat-card-content class="menu--card__content">
          <mat-card-title class="menu--card__title">
            <p>{{ translate.translateRequestTypes('LOAN') }}</p>
          </mat-card-title>
          <button
            (click)="navigateTo('loan')"
            class="menu--card__btn"
            mat-button
          >
            <mat-icon class="arrow">arrow_forward_ios</mat-icon>
          </button>
        </mat-card-content>
      </mat-card>
    </li>
  </ul>
</main>
